import { FormikProps, withFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from '@lib/formik'

import { Body1, Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { usePasswordValidation } from '@global/PasswordValidation/PasswordValidation'
import { createFormPasswordField } from '@global/formField/FormPasswordField'

import { FieldWrapper } from '@shared/components/FieldWrapper'

import styles from '../Generic.module.scss'

export interface PersonalDetailsStep5FormValues {
  firstName: string
  password: string
  confirmPassword: string
}

const PasswordFormField = createFormPasswordField<PersonalDetailsStep5FormValues>()

const PersonalDetailsStep5FormUI: React.FC<
  FormikProps<PersonalDetailsStep5FormValues> & OuterProps
> = (props) => {
  const { handleSubmit, values, isSubmitting, leadData } = props
  const { t } = useTranslation()
  const { password, confirmPassword } = values

  const { isPasswordValid, validationComponent } = usePasswordValidation({
    password,
    confirmPassword,
    leadData,
  })

  return (
    <React.Fragment>
      <Form className={styles.form} onSubmit={handleSubmit}>
        <Heading6 medium>{t('Password')}</Heading6>
        <FieldWrapper>
          <Body1 className='pb-2'>
            {t(
              'Sign up.Please create your new password, ensuring you use numbers, uppercase and lowercase letters.'
            )}
          </Body1>
          <PasswordFormField
            name={'password'}
            label={t('Sign up.Enter Password')}
            showLabel
            type='password'
            required
          />
          <PasswordFormField
            name={'confirmPassword'}
            label={t('Confirm Password')}
            showLabel
            type='password'
            required
          />
          {validationComponent}
        </FieldWrapper>

        <div className={styles.button}>
          <Button.Primary
            size='lg'
            type='submit'
            fullWidth
            iconRight={ArrowIcon.Right}
            loading={isSubmitting}
            disabled={isSubmitting || !isPasswordValid}
          >
            {t('Next')}
          </Button.Primary>
        </div>
      </Form>
    </React.Fragment>
  )
}

interface OuterProps {
  initialValues: PersonalDetailsStep5FormValues | undefined
  leadData: {
    id: string
    token: string
  }
  onSubmit(values: PersonalDetailsStep5FormValues): void
}

export const PersonalDetailsStep5Form = withFormik<OuterProps, PersonalDetailsStep5FormValues>({
  mapPropsToValues: ({ initialValues }) => {
    return {
      firstName: initialValues?.firstName || '',
      password: initialValues?.password || '',
      confirmPassword: initialValues?.password || '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      setSubmitting(true)
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
})(PersonalDetailsStep5FormUI)
